import React from "react";
import PropTypes from "prop-types";

const DateCellRenderer = ({ value, locale, long }) => {
  if (value == null) {
    return null;
  }

  let date;

  if (value instanceof Date) {
    date = value;
  } else if (typeof value === "string" || typeof value === "number") {
    const parsedDate = new Date(value);

    if (!Number.isNaN(parsedDate.getTime())) {
      date = parsedDate;
    }
  }

  if (!date) {
    return <span>{String(value)}</span>;
  }

  const formatter = long
    ? new Intl.DateTimeFormat(locale, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : new Intl.DateTimeFormat(locale);

  const formattedDate = formatter.format(date);

  return <span>{formattedDate}</span>;
};

DateCellRenderer.propTypes = {
  value: PropTypes.any,
  locale: PropTypes.string,
  long: PropTypes.bool,
};

export default DateCellRenderer;
